import { createUseThemedStyles } from '@/hooks';
import { AiChat, AiChatRef } from '@/components/ai-chat';
import { AiExampleQuestion } from '@/components';
import { useRef } from 'react';

const useStyles = createUseThemedStyles((theme) => ({
	layout: {
		display: 'flex',
		overflow: 'hidden',
		height: 'calc(100vh - 60px)',
		backgroundColor: theme.colors.white,
	},
	aiChatContainer: {
		width: '100%',
		height: '100%',
		margin: '0 auto',
	},
}));

export const EventStreamTest = () => {
	const classes = useStyles();
	const aiChatRef = useRef<AiChatRef>(null);

	return (
		<div className={classes.layout}>
			<div className={classes.aiChatContainer}>
				<AiChat
					ref={aiChatRef}
					noConversationState={
						<>
							<div className="mb-6 d-flex align-items-center justify-content-between">
								<h2 className="mb-0 text-primary">
									Welcome to AskHackett.ai<sup>&trade;</sup>
								</h2>
							</div>
							<p className="mb-3">
								AskHackett.ai is a custom-built Gen AI powered research solution which serves as a
								business-topic research assistant and productivity enhancer leveraging Hackett's
								proprietary IP sources to support client work and streamline research efforts.
							</p>
							<p className="mb-6">
								AskHackett.ai leverages large language models (LLMs) to provide responses to your
								research prompts based on Hackett's IP - currently including Advisory Research, Best
								Practices and a subset of our Metrics database. The LLM can also provide responses based
								on its public-domain trained insights.
							</p>
							<p className="mb-3">
								<strong>Example Prompts</strong>
							</p>
							<AiExampleQuestion
								className="mb-2"
								question="What are ways to optimize the purchase to pay process?"
								onClick={(s) => {
									aiChatRef.current?.setMessage(s);
								}}
							/>
							<AiExampleQuestion
								className="mb-2"
								question="What are emerging issues for the finance function?"
								onClick={(s) => {
									aiChatRef.current?.setMessage(s);
								}}
							/>
							<AiExampleQuestion
								question="How is AI impacting the role of the IT function?"
								onClick={(s) => {
									aiChatRef.current?.setMessage(s);
								}}
							/>
						</>
					}
				/>
			</div>
		</div>
	);
};
